var _rect, _path, _rect2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTw = function SvgTw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1934 6.47093C12.8859 6.60715 12.5557 6.69918 12.2085 6.74079C12.5627 6.52873 12.8344 6.19223 12.9625 5.79168C12.6312 5.98827 12.2641 6.13112 11.8735 6.20769C11.5606 5.87488 11.1151 5.6665 10.6218 5.6665C9.67488 5.6665 8.90691 6.43448 8.90691 7.38212C8.90691 7.51613 8.92237 7.64645 8.95109 7.77236C7.52521 7.70057 6.26207 7.01764 5.41604 5.98017C5.26878 6.2342 5.1841 6.52873 5.1841 6.8424C5.1841 7.43734 5.4871 7.9627 5.94692 8.27011C5.66565 8.26091 5.40131 8.18396 5.17011 8.05548V8.07756C5.17011 8.9085 5.761 9.60174 6.54592 9.75931C6.4016 9.79833 6.25028 9.81895 6.09419 9.81895C5.98374 9.81895 5.87587 9.80864 5.77131 9.78876C5.98963 10.4699 6.62286 10.9661 7.37353 10.9794C6.78632 11.4396 6.04669 11.7139 5.24338 11.7139C5.10495 11.7139 4.96836 11.7058 4.83398 11.6899C5.59312 12.177 6.49437 12.4605 7.46263 12.4605C10.6177 12.4605 12.3425 9.8473 12.3425 7.58092C12.3425 7.50729 12.3407 7.43292 12.3374 7.35929C12.6724 7.11704 12.9633 6.81552 13.1926 6.47203L13.1934 6.47093Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 15.5,
    height: 15.5,
    rx: 7.75,
    stroke: "#121626",
    strokeWidth: 1.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tw.d4b3aa3a.svg";
export { ForwardRef as ReactComponent };